/**
 * Sales > Leads route.
 *
 * Reference: spec section 15.7.
 */

import { createFileRoute } from '@tanstack/react-router';
import { LeadsBoard } from '@/components/sales/LeadsBoard';

export const Route = createFileRoute('/sales/leads')({
  component: LeadsView,
});

function LeadsView() {
  return <LeadsBoard />;
}
